<template>
  <div>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="300px"
      viewBox="0 0 255.75 411.125"
      enable-background="new 0 0 255.75 411.125"
      xml:space="preserve"
    >
      <rect fill="#EFEFF2" width="255.75" height="411.125" />
      <path
        fill="none"
        :stroke="color"
        stroke-miterlimit="10"
        d="M243.301,14.988"
      />
      <path
        fill="none"
        :stroke="color"
        stroke-miterlimit="10"
        d="M141.481,14.988"
      />
      <rect x="146.693" y="25.335" fill="#EFEFF2" width="46.901" height="6" />
      <rect x="202.011" y="25.333" fill="#EFEFF2" width="35.679" height="6" />
      <rect x="146.894" y="38.541" fill="#EFEFF2" width="46.901" height="6" />
      <rect x="202.211" y="38.539" fill="#EFEFF2" width="35.68" height="6" />
      <rect x="146.894" y="50.796" fill="#EFEFF2" width="46.899" height="6" />
      <rect
        x="202.211"
        y="50.794"
        fill="#EFEFF2"
        width="35.679"
        height="6.001"
      />
      <g id="Layer_5"></g>
      <path
        fill="#FFFFFF"
        d="M241.45,24.308v-9.656H17v11.081v5.897v76.426c0,4.18,3.582,7.568,8,7.568h208.597c4.418,0,8-3.389,8-7.568
	V25.733C241.597,25.246,241.544,24.77,241.45,24.308z"
      />
      <rect x="17" y="14.679" :fill="color" width="224.597" height="2.308" />
      <line
        fill="none"
        stroke="#C9C9C9"
        stroke-miterlimit="10"
        x1="17"
        y1="34.292"
        x2="241.597"
        y2="34.292"
      />
      <g>
        <path
          :fill="color"
          d="M27.487,27.536h1.952v0.592h-2.68v-5.576h0.728V27.536z"
        />
        <path
          :fill="color"
          d="M31.328,27.819c-0.428-0.243-0.765-0.581-1.013-1.016s-0.372-0.924-0.372-1.468s0.124-1.033,0.372-1.468
		s0.585-0.773,1.013-1.016c0.427-0.243,0.897-0.364,1.416-0.364c0.521,0,0.996,0.122,1.424,0.364
		c0.427,0.242,0.763,0.58,1.008,1.012c0.245,0.432,0.368,0.923,0.368,1.472c0,0.549-0.123,1.04-0.368,1.472
		c-0.246,0.432-0.582,0.769-1.008,1.012c-0.427,0.243-0.901,0.364-1.424,0.364C32.226,28.183,31.754,28.062,31.328,27.819z
		 M33.795,27.279c0.312-0.181,0.558-0.44,0.735-0.776c0.179-0.336,0.269-0.725,0.269-1.168c0-0.448-0.089-0.839-0.269-1.172
		c-0.179-0.333-0.423-0.591-0.731-0.772c-0.311-0.182-0.662-0.272-1.057-0.272s-0.746,0.09-1.056,0.272
		c-0.309,0.181-0.553,0.438-0.731,0.772c-0.18,0.333-0.269,0.724-0.269,1.172c0,0.443,0.089,0.832,0.269,1.168
		c0.179,0.336,0.424,0.595,0.735,0.776c0.313,0.182,0.663,0.272,1.052,0.272C33.133,27.551,33.482,27.461,33.795,27.279z"
        />
        <path
          :fill="color"
          d="M40.727,24.167c-0.155-0.325-0.378-0.577-0.672-0.756s-0.635-0.268-1.024-0.268s-0.739,0.089-1.052,0.268
		c-0.312,0.179-0.557,0.435-0.736,0.768c-0.179,0.333-0.268,0.719-0.268,1.156s0.089,0.821,0.268,1.152
		c0.18,0.331,0.425,0.585,0.736,0.764c0.313,0.179,0.663,0.268,1.052,0.268c0.544,0,0.992-0.163,1.345-0.488
		c0.352-0.325,0.558-0.765,0.615-1.32h-2.224v-0.592h3v0.56c-0.042,0.459-0.187,0.879-0.432,1.26
		c-0.246,0.381-0.568,0.683-0.969,0.904c-0.399,0.222-0.845,0.332-1.336,0.332c-0.518,0-0.988-0.121-1.416-0.364
		c-0.427-0.243-0.764-0.58-1.012-1.012c-0.248-0.432-0.372-0.92-0.372-1.464s0.124-1.033,0.372-1.468s0.585-0.773,1.012-1.016
		c0.428-0.243,0.898-0.364,1.416-0.364c0.593,0,1.116,0.147,1.572,0.44s0.788,0.707,0.996,1.24H40.727z"
        />
        <path
          :fill="color"
          d="M43.839,27.819c-0.427-0.243-0.765-0.581-1.013-1.016s-0.371-0.924-0.371-1.468s0.123-1.033,0.371-1.468
		s0.586-0.773,1.013-1.016s0.897-0.364,1.416-0.364c0.521,0,0.997,0.122,1.424,0.364s0.763,0.58,1.008,1.012
		c0.245,0.432,0.368,0.923,0.368,1.472c0,0.549-0.123,1.04-0.368,1.472c-0.246,0.432-0.582,0.769-1.008,1.012
		c-0.426,0.243-0.901,0.364-1.424,0.364C44.737,28.183,44.266,28.062,43.839,27.819z M46.307,27.279
		c0.313-0.181,0.558-0.44,0.736-0.776c0.178-0.336,0.268-0.725,0.268-1.168c0-0.448-0.089-0.839-0.268-1.172
		c-0.18-0.333-0.424-0.591-0.732-0.772c-0.31-0.182-0.662-0.272-1.056-0.272c-0.396,0-0.747,0.09-1.057,0.272
		c-0.309,0.181-0.553,0.438-0.731,0.772c-0.18,0.333-0.269,0.724-0.269,1.172c0,0.443,0.089,0.832,0.269,1.168
		c0.179,0.336,0.424,0.595,0.736,0.776c0.312,0.182,0.662,0.272,1.052,0.272C45.644,27.551,45.994,27.461,46.307,27.279z"
        />
      </g>
      <rect
        x="26.652"
        y="45.125"
        fill="#9B9B9B"
        width="83.912"
        height="3.168"
      />
      <rect
        x="26.652"
        y="52.622"
        fill="#9B9B9B"
        width="83.912"
        height="2.878"
      />
      <rect
        x="26.795"
        y="61.275"
        fill="#EFEFF2"
        width="102.504"
        height="2.684"
      />
      <rect
        x="26.795"
        y="67.275"
        fill="#EFEFF2"
        width="102.504"
        height="2.684"
      />
      <rect
        x="26.795"
        y="73.275"
        fill="#EFEFF2"
        width="102.504"
        height="2.684"
      />
      <path
        fill="#EFEFF2"
        d="M129.299,103.905c0,2.011-1.898,3.64-4.241,3.64H30.893c-2.342,0-4.241-1.629-4.241-3.64V86.116
	c0-2.011,1.898-3.64,4.241-3.64h94.165c2.343,0,4.241,1.629,4.241,3.64V103.905z"
      />
      <rect
        x="206.708"
        y="21.994"
        fill="#EFEFF2"
        width="25.539"
        height="2.684"
      />
      <rect
        x="195.042"
        y="26.994"
        fill="#5B5B5B"
        width="37.205"
        height="2.684"
      />
      <rect x="34.396" y="89.521" :fill="color" width="33.906" height="3.255" />
      <rect
        x="34.396"
        y="97.375"
        fill="#9B9B9B"
        width="83.912"
        height="3.487"
      />
      <image
        overflow="visible"
        width="500"
        height="322"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/images/status/rhomtrip-new.png"
        transform="matrix(0.1404 0 0 0.1521 162.0703 39.4634)"
      ></image>
      <path
        :fill="color"
        d="M219.808,95.367c-0.299,0-0.591,0.04-0.873,0.116c-0.154-0.07-0.317-0.116-0.493-0.116H185.05
	c-0.056,0-0.102,0.028-0.155,0.037c-0.094-0.009-0.186-0.037-0.283-0.037c-2.353,0-4.261,2.461-4.261,5.495
	c0,3.035,1.908,5.496,4.261,5.496c0.098,0,0.189-0.029,0.283-0.035c0.054,0.006,0.1,0.035,0.155,0.035h33.392
	c0.176,0,0.339-0.048,0.493-0.117c0.282,0.075,0.571,0.117,0.873,0.117c2.354,0,4.263-2.461,4.263-5.496
	C224.07,97.826,222.162,95.367,219.808,95.367z"
      />
      <rect x="17.375" y="121" fill="#9B9B9B" width="83.912" height="2.626" />
      <path
        fill="#FFFFFF"
        d="M241.597,151.709c0,2.762-2.186,5-4.883,5H21.882c-2.696,0-4.882-2.238-4.882-5v-20c0-2.762,2.186-5,4.882-5
	h214.832c2.697,0,4.883,2.238,4.883,5V151.709z"
      />
      <rect
        x="17.375"
        y="161.75"
        fill="#9B9B9B"
        width="83.912"
        height="2.626"
      />
      <image
        overflow="visible"
        width="236"
        height="177"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/images/tesla-model-s.png"
        transform="matrix(0.16 0 0 0.1617 21.5698 127.3975)"
      ></image>
      <rect
        x="73.353"
        y="137.695"
        fill="#B5B5B5"
        width="55.946"
        height="2.848"
      />
      <rect
        x="73.353"
        y="131.494"
        fill="#9B9B9B"
        width="64.897"
        height="2.848"
      />
      <rect
        x="73.353"
        y="143.959"
        fill="#B5B5B5"
        width="12.897"
        height="2.848"
      />
      <path
        fill="#FFFFFF"
        d="M241.597,189.128c0,2.139-1.309,3.872-2.925,3.872H20.3c-1.615,0-2.925-1.733-2.925-3.872v-18.074
	c0-2.139,1.31-3.872,2.925-3.872h218.372c1.616,0,2.925,1.733,2.925,3.872V189.128z"
      />
      <rect
        x="89.478"
        y="143.959"
        fill="#B5B5B5"
        width="12.897"
        height="2.848"
      />
      <rect
        x="29.024"
        y="175.682"
        fill="#B5B5B5"
        width="144.685"
        height="2.848"
      />
      <rect
        x="29.024"
        y="171.278"
        fill="#B5B5B5"
        width="12.897"
        height="2.848"
      />
      <rect
        x="29.024"
        y="186.182"
        fill="#B5B5B5"
        width="144.685"
        height="2.848"
      />
      <rect
        x="29.024"
        y="181.778"
        fill="#B5B5B5"
        width="12.897"
        height="2.848"
      />
      <path
        fill="#FFFFFF"
        stroke="#9B9B9B"
        stroke-width="0.25"
        stroke-miterlimit="10"
        d="M87.75,151.438
	c0,1.001-0.847,1.813-1.891,1.813H74.516c-1.044,0-1.891-0.812-1.891-1.813l0,0c0-1.001,0.847-1.813,1.891-1.813h11.344
	C86.903,149.625,87.75,150.437,87.75,151.438L87.75,151.438z"
      />
      <path
        fill="#FFFFFF"
        stroke="#9B9B9B"
        stroke-width="0.25"
        stroke-miterlimit="10"
        d="M104.603,151.438
	c0,1.001-0.847,1.813-1.891,1.813H91.368c-1.044,0-1.891-0.812-1.891-1.813l0,0c0-1.001,0.847-1.813,1.891-1.813h11.344
	C103.756,149.625,104.603,150.437,104.603,151.438L104.603,151.438z"
      />
      <path
        fill="#FFFFFF"
        stroke="#9B9B9B"
        stroke-width="0.25"
        stroke-miterlimit="10"
        d="M120.926,151.438
	c0,1.001-0.847,1.813-1.891,1.813h-11.344c-1.044,0-1.891-0.812-1.891-1.813l0,0c0-1.001,0.847-1.813,1.891-1.813h11.344
	C120.08,149.625,120.926,150.437,120.926,151.438L120.926,151.438z"
      />
      <image
        overflow="visible"
        width="32"
        height="32"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/icons/pointa.png"
        transform="matrix(0.1687 0 0 0.164 21.2256 171.251)"
      ></image>
      <image
        overflow="visible"
        width="32"
        height="32"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/icons/point-b.png"
        transform="matrix(0.1719 0 0 0.1602 21.1753 182.0635)"
      ></image>
      <path
        fill="#FFFFFF"
        d="M241.409,293.077c0,2.236-1.31,4.048-2.925,4.048H20.112c-1.615,0-2.925-1.812-2.925-4.048v-32.39
	c0-2.236,1.31-4.048,2.925-4.048h218.372c1.615,0,2.925,1.812,2.925,4.048V293.077z"
      />
      <path
        fill="#FFFFFF"
        d="M241.409,243.965c0,1.746-1.309,3.16-2.925,3.16H20.112c-1.615,0-2.925-1.414-2.925-3.16v-46.346
	c0-1.746,1.31-3.16,2.925-3.16h218.372c1.616,0,2.925,1.414,2.925,3.16V243.965z"
      />
      <rect
        x="22.691"
        y="204.015"
        fill="#B5B5B5"
        width="51.684"
        height="2.848"
      />
      <rect
        x="22.691"
        y="199.611"
        fill="#B5B5B5"
        width="18.351"
        height="2.848"
      />
      <rect
        x="22.691"
        y="216.216"
        fill="#B5B5B5"
        width="51.684"
        height="2.848"
      />
      <rect
        x="22.691"
        y="211.813"
        fill="#B5B5B5"
        width="18.351"
        height="2.848"
      />
      <rect
        x="22.691"
        y="227.883"
        fill="#B5B5B5"
        width="51.684"
        height="2.848"
      />
      <rect
        x="22.691"
        y="223.479"
        fill="#B5B5B5"
        width="18.351"
        height="2.848"
      />
      <rect
        x="22.691"
        y="239.716"
        fill="#B5B5B5"
        width="51.684"
        height="2.848"
      />
      <rect
        x="22.691"
        y="235.313"
        fill="#B5B5B5"
        width="18.351"
        height="2.848"
      />
      <rect
        x="85.534"
        y="216.215"
        fill="#B5B5B5"
        width="31.008"
        height="2.848"
      />
      <rect
        x="85.534"
        y="211.812"
        fill="#B5B5B5"
        width="18.351"
        height="2.848"
      />
      <rect
        x="126.701"
        y="216.217"
        fill="#B5B5B5"
        width="31.008"
        height="2.848"
      />
      <rect
        x="126.701"
        y="211.813"
        fill="#B5B5B5"
        width="18.35"
        height="2.848"
      />
      <rect
        x="166.701"
        y="215.992"
        fill="#B5B5B5"
        width="31.008"
        height="2.848"
      />
      <rect
        x="166.701"
        y="211.589"
        fill="#B5B5B5"
        width="18.35"
        height="2.848"
      />
      <rect
        x="205.875"
        y="199.611"
        :fill="color"
        width="30.01"
        height="2.848"
      />
      <rect
        x="17.375"
        y="251.916"
        fill="#9B9B9B"
        width="83.912"
        height="2.626"
      />
      <rect
        x="22.691"
        y="261.583"
        fill="#9B9B9B"
        width="41.956"
        height="2.626"
      />
      <rect
        x="213.208"
        y="264.209"
        fill="#9B9B9B"
        width="22.677"
        height="2.626"
      />
      <rect
        x="213.208"
        y="268.973"
        fill="#B5B5B5"
        width="22.677"
        height="2.626"
      />
      <rect
        x="213.208"
        y="273.642"
        fill="#B5B5B5"
        width="22.677"
        height="2.626"
      />
      <rect
        x="213.208"
        y="278.993"
        fill="#B5B5B5"
        width="22.677"
        height="2.626"
      />
      <rect
        x="22.691"
        y="267.549"
        fill="#B5B5B5"
        width="51.684"
        height="2.848"
      />
      <rect
        x="22.691"
        y="273.216"
        fill="#B5B5B5"
        width="51.684"
        height="2.848"
      />
      <rect
        x="22.691"
        y="278.882"
        fill="#B5B5B5"
        width="51.684"
        height="2.848"
      />
      <line
        fill="none"
        stroke="#C9C9C9"
        stroke-miterlimit="10"
        x1="22.691"
        y1="286.064"
        x2="235.885"
        y2="286.064"
      />
      <rect
        x="22.691"
        y="289.917"
        fill="#9B9B9B"
        width="41.956"
        height="2.626"
      />
      <rect
        x="213.207"
        y="289.917"
        fill="#9B9B9B"
        width="22.678"
        height="2.626"
      />
      <g>
        <rect
          x="102.18"
          y="395.61"
          fill="#B5B5B5"
          width="51.684"
          height="2.848"
        />
      </g>
      <g>
        <rect
          x="109.755"
          y="372.11"
          fill="#B5B5B5"
          width="37.695"
          height="2.848"
        />
      </g>
      <rect x="93.911" y="390.777" fill="#B5B5B5" width="69.5" height="2.848" />
      <g>
        <path
          :fill="color"
          d="M119.669,364.357v0.443h-1.818v1.41h1.477v0.444h-1.477v1.884h-0.546v-4.182H119.669z"
        />
        <path
          :fill="color"
          d="M120.329,365.998c0.136-0.254,0.323-0.451,0.562-0.591c0.237-0.14,0.503-0.21,0.795-0.21
		c0.288,0,0.537,0.062,0.75,0.186c0.212,0.124,0.369,0.28,0.474,0.468v-0.6h0.552v3.288h-0.552v-0.612
		c-0.108,0.192-0.27,0.352-0.483,0.478s-0.463,0.188-0.747,0.188c-0.292,0-0.556-0.071-0.792-0.216
		c-0.235-0.144-0.422-0.346-0.558-0.605c-0.136-0.261-0.204-0.557-0.204-0.889C120.125,366.547,120.193,366.252,120.329,365.998z
		 M122.759,366.241c-0.1-0.185-0.234-0.325-0.404-0.423c-0.17-0.099-0.357-0.147-0.562-0.147s-0.39,0.048-0.558,0.145
		c-0.168,0.096-0.302,0.235-0.402,0.42c-0.1,0.184-0.149,0.399-0.149,0.647c0,0.252,0.05,0.472,0.149,0.657
		c0.101,0.186,0.234,0.328,0.402,0.426c0.168,0.099,0.354,0.147,0.558,0.147s0.392-0.049,0.562-0.147
		c0.17-0.098,0.305-0.24,0.404-0.426c0.101-0.186,0.15-0.403,0.15-0.651S122.859,366.425,122.759,366.241z"
        />
        <path
          :fill="color"
          d="M125.608,368.035l1.021-2.784h0.582l-1.29,3.288h-0.636l-1.29-3.288h0.588L125.608,368.035z"
        />
        <path
          :fill="color"
          d="M127.77,364.609c-0.072-0.072-0.108-0.16-0.108-0.265c0-0.104,0.036-0.191,0.108-0.264
		c0.071-0.072,0.159-0.108,0.264-0.108c0.1,0,0.185,0.036,0.255,0.108s0.104,0.16,0.104,0.264c0,0.104-0.034,0.192-0.104,0.265
		c-0.07,0.071-0.155,0.107-0.255,0.107C127.929,364.717,127.841,364.681,127.77,364.609z M128.297,365.251v3.288h-0.546v-3.288
		H128.297z"
        />
        <path
          :fill="color"
          d="M129.227,365.998c0.136-0.254,0.325-0.451,0.567-0.591c0.241-0.14,0.519-0.21,0.831-0.21
		c0.403,0,0.736,0.098,0.999,0.294c0.262,0.196,0.435,0.468,0.519,0.815h-0.588c-0.056-0.199-0.165-0.357-0.327-0.474
		s-0.363-0.174-0.603-0.174c-0.313,0-0.564,0.107-0.757,0.321c-0.191,0.214-0.287,0.517-0.287,0.908
		c0,0.396,0.096,0.702,0.287,0.918c0.192,0.217,0.444,0.324,0.757,0.324c0.239,0,0.439-0.056,0.6-0.168
		c0.16-0.111,0.271-0.271,0.33-0.479h0.588c-0.088,0.336-0.264,0.604-0.528,0.807c-0.264,0.202-0.594,0.303-0.989,0.303
		c-0.313,0-0.59-0.069-0.831-0.21c-0.242-0.14-0.432-0.338-0.567-0.594s-0.204-0.556-0.204-0.9
		C129.022,366.549,129.091,366.252,129.227,365.998z"
        />
        <path
          :fill="color"
          d="M133.465,368.383c-0.25-0.14-0.445-0.339-0.588-0.597c-0.142-0.258-0.213-0.557-0.213-0.897
		c0-0.336,0.073-0.633,0.219-0.891c0.146-0.258,0.346-0.456,0.598-0.594c0.252-0.139,0.534-0.207,0.846-0.207
		c0.313,0,0.594,0.068,0.846,0.207c0.252,0.138,0.451,0.335,0.598,0.591c0.146,0.256,0.219,0.554,0.219,0.894
		c0,0.341-0.075,0.64-0.225,0.897c-0.15,0.258-0.354,0.457-0.609,0.597c-0.256,0.141-0.54,0.21-0.852,0.21
		C133.994,368.593,133.715,368.523,133.465,368.383z M134.854,367.975c0.172-0.092,0.311-0.229,0.417-0.413
		c0.105-0.185,0.159-0.408,0.159-0.673c0-0.264-0.053-0.487-0.156-0.672c-0.104-0.184-0.24-0.32-0.408-0.411
		c-0.168-0.09-0.35-0.135-0.546-0.135c-0.2,0-0.383,0.045-0.549,0.135c-0.166,0.091-0.299,0.228-0.399,0.411
		c-0.1,0.185-0.149,0.408-0.149,0.672c0,0.269,0.049,0.494,0.146,0.679c0.098,0.184,0.229,0.32,0.394,0.411
		c0.163,0.09,0.344,0.135,0.54,0.135C134.498,368.113,134.683,368.067,134.854,367.975z"
        />
        <path
          :fill="color"
          d="M139.282,365.554c0.248,0.242,0.372,0.592,0.372,1.047v1.938h-0.54v-1.86c0-0.327-0.082-0.579-0.246-0.753
		s-0.388-0.261-0.672-0.261c-0.288,0-0.518,0.09-0.688,0.271c-0.17,0.18-0.255,0.441-0.255,0.785v1.818h-0.546v-3.288h0.546v0.468
		c0.108-0.168,0.255-0.298,0.441-0.39c0.186-0.092,0.391-0.138,0.615-0.138C138.71,365.191,139.034,365.313,139.282,365.554z"
        />
      </g>
      <image
        overflow="visible"
        width="64"
        height="64"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/linkedin.png"
        transform="matrix(0.1068 0 0 0.1032 113.6704 376.792)"
      ></image>
      <image
        overflow="visible"
        width="64"
        height="64"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/instagram-1.png"
        transform="matrix(0.109 0 0 0.1092 121.502 376.5986)"
      ></image>
      <image
        overflow="visible"
        width="64"
        height="64"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/facebook.png"
        transform="matrix(0.1038 0 0 0.1021 129.2207 376.8271)"
      ></image>
      <image
        overflow="visible"
        width="64"
        height="64"
        xlink:href="https://upcdn.io/FW25b8h/raw/templates/emails/icons/social-media/twitter.png"
        transform="matrix(0.1024 0 0 0.1021 137.1035 376.8271)"
      ></image>
      <rect x="17.375" y="303.625" :fill="color" width="224.034" height="35" />
      <rect
        x="25.507"
        y="312.625"
        fill="#FFFFFF"
        width="51.684"
        height="2.848"
      />
      <rect
        x="25.507"
        y="321.125"
        fill="#FFFFFF"
        width="110.369"
        height="2.848"
      />
      <rect
        x="25.507"
        y="327.125"
        fill="#FFFFFF"
        width="110.369"
        height="2.848"
      />
      <path
        fill="#FFFFFF"
        d="M227.984,315.629c-0.299,0-0.591,0.04-0.873,0.116c-0.154-0.07-0.317-0.116-0.493-0.116h-33.392
	c-0.056,0-0.102,0.028-0.155,0.037c-0.094-0.009-0.186-0.037-0.283-0.037c-2.353,0-4.261,2.461-4.261,5.495
	c0,3.035,1.908,5.496,4.261,5.496c0.098,0,0.189-0.029,0.283-0.035c0.054,0.006,0.1,0.035,0.155,0.035h33.392
	c0.176,0,0.339-0.048,0.493-0.117c0.282,0.075,0.571,0.117,0.873,0.117c2.354,0,4.263-2.461,4.263-5.496
	C232.247,318.088,230.339,315.629,227.984,315.629z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "template-email",
  components: {},
  props: {
    color: {
      type: String,
      default: "",
      description: "theme color"
    }
  }
};
</script>
